import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ManagerLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Skip password, go directly to manager page
    sessionStorage.setItem('managerAuth', 'true');
    navigate('/manager');
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" dir="rtl">
      <p>מעבר לדף מנהל...</p>
    </div>
  );
};

export default ManagerLogin;
